import { Navigator } from './Navigator';
import { NavigatorContext } from './NavigatorContext';
import { useWidth } from '../UseWidth';
import React, { useEffect } from 'react';
export const NavigatorProvider = ({ children, navigatorDefaultOpenOnDesktop, isNavigatorVisible, ...rest }) => {
    const width = useWidth();
    const initialStateMap = {
        xs: 'drawer-closed',
        sm: 'desktop-mini',
        md: 'desktop-mini',
        lg: navigatorDefaultOpenOnDesktop ? 'desktop-full' : 'desktop-mini',
        xl: navigatorDefaultOpenOnDesktop ? 'desktop-full' : 'desktop-mini',
    };
    const [navigatorState, setNavigatorState] = React.useState(initialStateMap[width]);
    const [lastWidth, setWidth] = React.useState(width);
    const nextToggleStateMap = {
        'drawer-open': 'drawer-closed',
        'drawer-closed': 'drawer-open',
        'desktop-mini': 'desktop-full',
        'desktop-full': 'desktop-mini',
    };
    const toggleNavigator = () => setNavigatorState(nextToggleStateMap[navigatorState]);
    useEffect(() => {
        if (width !== lastWidth) {
            if (width === 'xs') {
                setNavigatorState('drawer-closed');
            }
            else if (width === 'sm') {
                setNavigatorState('desktop-mini');
            }
            else if (lastWidth === 'xs' || lastWidth === 'sm') {
                setNavigatorState('desktop-mini');
            }
            setWidth(width);
        }
    }, [lastWidth, navigatorState, width]);
    return (React.createElement(NavigatorContext.Provider, { value: { navigatorState, toggleNavigator } },
        isNavigatorVisible && React.createElement(Navigator, Object.assign({ navigatorState: navigatorState, toggleNavigator: toggleNavigator }, rest)),
        children));
};
//# sourceMappingURL=NavigatorProvider.js.map